var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _mask4, _path6, _path7, _mask5, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6432_44569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99C12 3.44324 12.4446 2.99437 12.988 3.05439C14.2253 3.19105 15.4246 3.58336 16.5082 4.21049C17.8783 5.00344 19.015 6.14374 19.8036 7.51634C20.5923 8.88893 21.0049 10.4453 21 12.0283C20.995 13.6113 20.5726 15.165 19.7753 16.5326C18.9781 17.9002 17.8342 19.0334 16.4591 19.8177C15.0841 20.602 13.5264 21.0098 11.9434 20.9998C10.3605 20.9899 8.80808 20.5626 7.44298 19.761C6.36335 19.1271 5.43107 18.2768 4.7025 17.2675C4.3825 16.8242 4.55404 16.2161 5.02983 15.9467C5.50561 15.6773 6.10454 15.8501 6.43815 16.2832C6.98568 16.9942 7.66642 17.5961 8.44553 18.0536C9.51031 18.6788 10.7212 19.0121 11.9559 19.0199C13.1906 19.0276 14.4056 18.7096 15.4781 18.0978C16.5507 17.486 17.4429 16.6022 18.0647 15.5354C18.6866 14.4687 19.0161 13.2568 19.02 12.0221C19.0238 10.7873 18.702 9.57337 18.0868 8.50274C17.4717 7.43212 16.5851 6.54268 15.5164 5.92418C14.7344 5.47162 13.8752 5.17583 12.9867 5.04969C12.4454 4.97284 12 4.53676 12 3.99Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99C12 3.44324 12.4446 2.99437 12.988 3.05439C14.2253 3.19105 15.4246 3.58336 16.5082 4.21049C17.8783 5.00344 19.015 6.14374 19.8036 7.51634C20.5923 8.88893 21.0049 10.4453 21 12.0283C20.995 13.6113 20.5726 15.165 19.7753 16.5326C18.9781 17.9002 17.8342 19.0334 16.4591 19.8177C15.0841 20.602 13.5264 21.0098 11.9434 20.9998C10.3605 20.9899 8.80808 20.5626 7.44298 19.761C6.36335 19.1271 5.43107 18.2768 4.7025 17.2675C4.3825 16.8242 4.55404 16.2161 5.02983 15.9467C5.50561 15.6773 6.10454 15.8501 6.43815 16.2832C6.98568 16.9942 7.66642 17.5961 8.44553 18.0536C9.51031 18.6788 10.7212 19.0121 11.9559 19.0199C13.1906 19.0276 14.4056 18.7096 15.4781 18.0978C16.5507 17.486 17.4429 16.6022 18.0647 15.5354C18.6866 14.4687 19.0161 13.2568 19.02 12.0221C19.0238 10.7873 18.702 9.57337 18.0868 8.50274C17.4717 7.43212 16.5851 6.54268 15.5164 5.92418C14.7344 5.47162 13.8752 5.17583 12.9867 5.04969C12.4454 4.97284 12 4.53676 12 3.99Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_6432_44569)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99C12 3.44324 12.4446 2.99437 12.988 3.05439C14.2253 3.19105 15.4246 3.58336 16.5082 4.21049C17.8783 5.00344 19.015 6.14374 19.8036 7.51634C20.5923 8.88893 21.0049 10.4453 21 12.0283C20.995 13.6113 20.5726 15.165 19.7753 16.5326C18.9781 17.9002 17.8342 19.0334 16.4591 19.8177C15.0841 20.602 13.5264 21.0098 11.9434 20.9998C10.3605 20.9899 8.80808 20.5626 7.44298 19.761C6.36335 19.1271 5.43107 18.2768 4.7025 17.2675C4.3825 16.8242 4.55404 16.2161 5.02983 15.9467C5.50561 15.6773 6.10454 15.8501 6.43815 16.2832C6.98568 16.9942 7.66642 17.5961 8.44553 18.0536C9.51031 18.6788 10.7212 19.0121 11.9559 19.0199C13.1906 19.0276 14.4056 18.7096 15.4781 18.0978C16.5507 17.486 17.4429 16.6022 18.0647 15.5354C18.6866 14.4687 19.0161 13.2568 19.02 12.0221C19.0238 10.7873 18.702 9.57337 18.0868 8.50274C17.4717 7.43212 16.5851 6.54268 15.5164 5.92418C14.7344 5.47162 13.8752 5.17583 12.9867 5.04969C12.4454 4.97284 12 4.53676 12 3.99Z",
    stroke: "url(#paint0_linear_6432_44569)",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_6432_44569)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_6432_44569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8512 5.86446C6.49975 5.44561 6.55178 4.816 7.00667 4.51266C7.71331 4.04143 8.48316 3.67258 9.29319 3.41714C9.81464 3.2527 10.3379 3.60667 10.4441 4.14302C10.5503 4.67937 10.1981 5.19365 9.682 5.37419C9.19427 5.5448 8.72683 5.76876 8.28824 6.04197C7.82415 6.33106 7.20266 6.2833 6.8512 5.86446Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.682 5.37419L9.02162 3.48636L9.682 5.37419ZM7.00667 4.51266L8.11628 6.17661C8.66589 5.81011 9.26467 5.52322 9.89469 5.32455L9.29319 3.41714L8.69169 1.50973C7.70166 1.82194 6.76074 2.27275 5.89706 2.8487L7.00667 4.51266ZM9.682 5.37419L9.02162 3.48636C8.39493 3.70559 7.79432 3.99335 7.23078 4.34439L8.28824 6.04197L9.3457 7.73955C9.65933 7.54418 9.9936 7.38402 10.3424 7.26202L9.682 5.37419ZM8.28824 6.04197L7.23078 4.34439C7.3751 4.25449 7.55205 4.20944 7.74505 4.23056C7.94882 4.25285 8.19602 4.3557 8.38329 4.57888L6.8512 5.86446L5.31911 7.15003C6.41833 8.46003 8.18652 8.46163 9.3457 7.73955L8.28824 6.04197ZM10.4441 4.14302L8.48221 4.53149C8.42562 4.24569 8.50036 3.9886 8.61067 3.81582C8.71514 3.65218 8.86113 3.5425 9.02162 3.48636L9.682 5.37419L10.3424 7.26202C11.6315 6.81108 12.7382 5.43206 12.406 3.75455L10.4441 4.14302ZM9.29319 3.41714L9.89469 5.32455C9.13771 5.56326 8.5775 5.01275 8.48221 4.53149L10.4441 4.14302L12.406 3.75455C12.0983 2.2006 10.4916 0.942145 8.69169 1.50973L9.29319 3.41714ZM7.00667 4.51266L5.89706 2.8487C4.32691 3.89575 4.30086 5.93652 5.31911 7.15003L6.8512 5.86446L8.38329 4.57888C8.69864 4.9547 8.77665 5.73625 8.11628 6.17661L7.00667 4.51266Z",
    fill: "black",
    mask: "url(#path-2-inside-2_6432_44569)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.682 5.37419L9.02162 3.48636L9.682 5.37419ZM7.00667 4.51266L8.11628 6.17661C8.66589 5.81011 9.26467 5.52322 9.89469 5.32455L9.29319 3.41714L8.69169 1.50973C7.70166 1.82194 6.76074 2.27275 5.89706 2.8487L7.00667 4.51266ZM9.682 5.37419L9.02162 3.48636C8.39493 3.70559 7.79432 3.99335 7.23078 4.34439L8.28824 6.04197L9.3457 7.73955C9.65933 7.54418 9.9936 7.38402 10.3424 7.26202L9.682 5.37419ZM8.28824 6.04197L7.23078 4.34439C7.3751 4.25449 7.55205 4.20944 7.74505 4.23056C7.94882 4.25285 8.19602 4.3557 8.38329 4.57888L6.8512 5.86446L5.31911 7.15003C6.41833 8.46003 8.18652 8.46163 9.3457 7.73955L8.28824 6.04197ZM10.4441 4.14302L8.48221 4.53149C8.42562 4.24569 8.50036 3.9886 8.61067 3.81582C8.71514 3.65218 8.86113 3.5425 9.02162 3.48636L9.682 5.37419L10.3424 7.26202C11.6315 6.81108 12.7382 5.43206 12.406 3.75455L10.4441 4.14302ZM9.29319 3.41714L9.89469 5.32455C9.13771 5.56326 8.5775 5.01275 8.48221 4.53149L10.4441 4.14302L12.406 3.75455C12.0983 2.2006 10.4916 0.942145 8.69169 1.50973L9.29319 3.41714ZM7.00667 4.51266L5.89706 2.8487C4.32691 3.89575 4.30086 5.93652 5.31911 7.15003L6.8512 5.86446L8.38329 4.57888C8.69864 4.9547 8.77665 5.73625 8.11628 6.17661L7.00667 4.51266Z",
    fill: "url(#paint1_linear_6432_44569)",
    mask: "url(#path-2-inside-2_6432_44569)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_6432_44569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22793 10.0622C3.69741 9.92993 3.36942 9.38999 3.55914 8.8772C3.85384 8.08061 4.25986 7.3297 4.76504 6.64692C5.09025 6.20739 5.72165 6.18618 6.12283 6.55767C6.524 6.92917 6.54134 7.55226 6.22993 8.00167C5.93562 8.42638 5.6891 8.88232 5.49486 9.36115C5.28933 9.86781 4.75845 10.1945 4.22793 10.0622Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22793 10.0622C3.69741 9.92993 3.36942 9.38999 3.55914 8.8772C3.85384 8.08061 4.25986 7.3297 4.76504 6.64692C5.09025 6.20739 5.72165 6.18618 6.12283 6.55767C6.524 6.92917 6.54134 7.55226 6.22993 8.00167C5.93562 8.42638 5.6891 8.88232 5.49486 9.36115C5.28933 9.86781 4.75845 10.1945 4.22793 10.0622Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-3_6432_44569)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_6432_44569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22793 10.0622C3.69741 9.92993 3.36942 9.38999 3.55914 8.8772C3.85384 8.08061 4.25986 7.3297 4.76504 6.64692C5.09025 6.20739 5.72165 6.18618 6.12283 6.55767C6.524 6.92917 6.54134 7.55226 6.22993 8.00167C5.93562 8.42638 5.6891 8.88232 5.49486 9.36115C5.28933 9.86781 4.75845 10.1945 4.22793 10.0622Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22793 10.0622C3.69741 9.92993 3.36942 9.38999 3.55914 8.8772C3.85384 8.08061 4.25986 7.3297 4.76504 6.64692C5.09025 6.20739 5.72165 6.18618 6.12283 6.55767C6.524 6.92917 6.54134 7.55226 6.22993 8.00167C5.93562 8.42638 5.6891 8.88232 5.49486 9.36115C5.28933 9.86781 4.75845 10.1945 4.22793 10.0622Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-5-inside-4_6432_44569)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22793 10.0622C3.69741 9.92993 3.36942 9.38999 3.55914 8.8772C3.85384 8.08061 4.25986 7.3297 4.76504 6.64692C5.09025 6.20739 5.72165 6.18618 6.12283 6.55767C6.524 6.92917 6.54134 7.55226 6.22993 8.00167C5.93562 8.42638 5.6891 8.88232 5.49486 9.36115C5.28933 9.86781 4.75845 10.1945 4.22793 10.0622Z",
    stroke: "url(#paint2_linear_6432_44569)",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-5-inside-4_6432_44569)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-5_6432_44569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62676 15.1298C4.12346 15.3434 3.53657 15.1096 3.37948 14.5859C3.13545 13.7723 3.00779 12.9283 3.00034 12.0789C2.99555 11.5322 3.48704 11.1353 4.03101 11.1905C4.57497 11.2458 4.9638 11.733 4.98556 12.2793C5.00612 12.7956 5.08362 13.3081 5.21666 13.8074C5.35743 14.3357 5.13005 14.9161 4.62676 15.1298Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62676 15.1298C4.12346 15.3434 3.53657 15.1096 3.37948 14.5859C3.13545 13.7723 3.00779 12.9283 3.00034 12.0789C2.99555 11.5322 3.48704 11.1353 4.03101 11.1905C4.57497 11.2458 4.9638 11.733 4.98556 12.2793C5.00612 12.7956 5.08362 13.3081 5.21666 13.8074C5.35743 14.3357 5.13005 14.9161 4.62676 15.1298Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-6-inside-5_6432_44569)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62676 15.1298C4.12346 15.3434 3.53657 15.1096 3.37948 14.5859C3.13545 13.7723 3.00779 12.9283 3.00034 12.0789C2.99555 11.5322 3.48704 11.1353 4.03101 11.1905C4.57497 11.2458 4.9638 11.733 4.98556 12.2793C5.00612 12.7956 5.08362 13.3081 5.21666 13.8074C5.35743 14.3357 5.13005 14.9161 4.62676 15.1298Z",
    stroke: "url(#paint3_linear_6432_44569)",
    strokeWidth: 4,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-6-inside-5_6432_44569)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L12 15",
    stroke: "url(#paint4_linear_6432_44569)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L9 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L9 12",
    stroke: "url(#paint5_linear_6432_44569)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6432_44569",
    x1: -0.652173,
    y1: -7.96876,
    x2: 22.9052,
    y2: -7.01776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6432_44569",
    x1: 5.31771,
    y1: 1.06894,
    x2: 11.0984,
    y2: 1.36794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6432_44569",
    x1: -0.652173,
    y1: -7.96876,
    x2: 22.9052,
    y2: -7.01776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6432_44569",
    x1: -0.652173,
    y1: -7.96876,
    x2: 22.9052,
    y2: -7.01776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6432_44569",
    x1: 10.1686,
    y1: 8.03791,
    x2: 13.2572,
    y2: 15.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6432_44569",
    x1: 7,
    y1: 10.002,
    x2: 17.9372,
    y2: 14.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryIcon);
export default __webpack_public_path__ + "static/media/storyIcon.c84cfe726a7c7b60e057d39e56f6a20c.svg";
export { ForwardRef as ReactComponent };